export const checkStatus = (list, permissions, permission) => {
    let tableList = [...list]
    tableList.map((item,key) => {
        if(permissions[key].id_permission_type > permission)
            item.status = true
    })
    return tableList
}